// Community Storage Management APIs

// Storage Place Management APIs

/**
 * @function ApiClient#GetStoragePlaceList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetStoragePlaceList(cid, options = {}) {
  return await this._get(`/community/${cid}/storage_place_list`, options);
}

/**
 * @function ApiClient#AddStoragePlace
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} placeName
 * @param {any} options = {}
 */
export async function AddStoragePlace(cid, placeName, options = {}) {
  return await this._post(`/community/${cid}/storage_place?p=${placeName}`, null, options);
}

/**
 * @function ApiClient#UpdateStoragePlace
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} places
 * @param {any} options = {}
 */
export async function UpdateStoragePlace(cid, places, options = {}) {
  return await this._put(`/community/${cid}/storage_place`, places, options);
}

/**
 * @function ApiClient#DeleteStoragePlace
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} placeName
 * @param {any} options = {}
 */
export async function DeleteStoragePlace(cid, placeName, options = {}) {
  return await this._delete(`/community/${cid}/storage_place?p=${placeName}`, options);
}

// Storage Type Management APIs

/**
 * @function ApiClient#GetStorageTypeList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetStorageTypeList(cid, options = {}) {
  return await this._get(`/community/${cid}/storage_type_list`, options);
}

/**
 * @function ApiClient#AddStorageType
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} typeName
 * @param {any} options = {}
 */
export async function AddStorageType(cid, typeName, options = {}) {
  return await this._post(`/community/${cid}/storage_type?p=${typeName}`, null, options);
}

/**
 * @function ApiClient#UpdateStorageType
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} types
 * @param {any} options = {}
 */
export async function UpdateStorageType(cid, types, options = {}) {
  return await this._put(`/community/${cid}/storage_type`, types, options);
}

/**
 * @function ApiClient#DeleteStorageType
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} typeName
 * @param {any} options = {}
 */
export async function DeleteStorageType(cid, typeName, options = {}) {
  return await this._delete(`/community/${cid}/storage_type?p=${typeName}`, options);
}

// Storage Unit Management APIs

/**
 * @function ApiClient#GetStorageUnitList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetStorageUnitList(cid, options = {}) {
  return await this._get(`/community/${cid}/storage_unit_list`, options);
}

/**
 * @function ApiClient#AddStorageUnit
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} unitName
 * @param {any} options = {}
 */
export async function AddStorageUnit(cid, unitName, options = {}) {
  return await this._post(`/community/${cid}/storage_unit?p=${unitName}`, null, options);
}

/**
 * @function ApiClient#UpdateStorageUnit
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} units
 * @param {any} options = {}
 */
export async function UpdateStorageUnit(cid, units, options = {}) {
  return await this._put(`/community/${cid}/storage_unit`, units, options);
}

/**
 * @function ApiClient#DeleteStorageUnit
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} unitName
 * @param {any} options = {}
 */
export async function DeleteStorageUnit(cid, unitName, options = {}) {
  return await this._delete(`/community/${cid}/storage_unit?p=${unitName}`, options);
}

// Storage CRUD APIs

/**
 * @function ApiClient#GetStorageList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} storageType
 * @param {any} storageName
 * @param {any} storagePlace
 * @param {any} storageStatus
 * @param {object} params 參數。
 * @param {any} params.sortBy
 * @param {any} params.sortDesc
 * @param {any} params.page
 * @param {any} params.itemsPerPage
 * @param {any} options = {}
 */
export async function GetStorageList(cid, storageType, storageName, storagePlace, storageStatus, { sortBy, sortDesc, page, itemsPerPage }, options = {}) {
  if (!storageType) storageType = "";
  if (!storageName) storageName = "";
  if (!storagePlace) storagePlace = "";
  if (!storageStatus) storageStatus = "";
  return await this._get(
    `/community/${cid}/storage_list?st=${storageType}&sn=${storageName}&sp=${storagePlace}&ss=${storageStatus}&p=${page}&sb=${sortBy}&sd=${sortDesc}&pp=${itemsPerPage}`,
    options,
  );
}

/**
 * @function ApiClient#AddStorage
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} storageData
 * @param {any} options = {}
 */
export async function AddStorage(cid, storageData, options = {}) {
  return await this._post(`/community/${cid}/storage`, storageData, options);
}

/**
 * @function ApiClient#UpdateStorage
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} storageData
 * @param {any} options = {}
 */
export async function UpdateStorage(cid, storageData, options = {}) {
  return await this._put(`/community/${cid}/storage`, storageData, options);
}

/**
 * @function ApiClient#DeleteStorage
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} storageID
 * @param {any} options = {}
 */
export async function DeleteStorage(cid, storageID, options = {}) {
  return await this._delete(`/community/${cid}/storage/${storageID}`, options);
}

/**
 * @function ApiClient#UpdateStorageStock
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} schData
 * @param {any} options = {}
 */
export async function UpdateStorageStock(cid, schData, options = {}) {
  return await this._put(`/community/${cid}/storage_stock`, schData, options);
}

/**
 * @function ApiClient#GetStorageChangeHistory
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} sid
 * @param {any} startTime
 * @param {any} endTime
 * @param {any} changeType
 * @param {object} params 參數。
 * @param {any} params.sortBy
 * @param {any} params.sortDesc
 * @param {any} params.page
 * @param {any} params.itemsPerPage
 * @param {any} options = {}
 */
export async function GetStorageChangeHistory(cid, sid, startTime, endTime, changeType, { sortBy, sortDesc, page, itemsPerPage }, options = {}) {
  if (!startTime) startTime = "";
  if (!endTime) endTime = "";
  if (!changeType) changeType = "";
  return await this._get(
    `/community/${cid}/storage_change_history?sid=${sid}&st=${startTime}&et=${endTime}&ct=${changeType}&p=${page}&sb=${sortBy}&sd=${sortDesc}&pp=${itemsPerPage}`,
    options,
  );
}
